import { render, staticRenderFns } from "./teacherGroupList.vue?vue&type=template&id=37ced52e&scoped=true&"
import script from "./teacherGroupList.vue?vue&type=script&lang=js&"
export * from "./teacherGroupList.vue?vue&type=script&lang=js&"
import style0 from "./teacherGroupList.vue?vue&type=style&index=0&id=37ced52e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ced52e",
  null
  
)

export default component.exports